<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  interface Props {
    value: DataListValue;
    problems?: string[];
    key?: string;
    onevent?: (payload: any) => void;
  }

  let { value, problems = [], key = '', onevent }: Props = $props();
</script>

{#if value && value.component}
  <div class="value-comp">
    <value.component {...value.props} {onevent} />
  </div>
{:else if !value?.alert || value?.actualValue}
  <div data-cy={`${key}-v`} class="value">
    <div class="text">
      {value?.actualValue || (typeof value !== 'object' && value) || EmptyLabelDefault}
    </div>
    {#if problems && problems.includes(key)}
      <div class="problem">{''}</div>
    {/if}
  </div>
{/if}

<style>
  .value,
  .value-comp {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .problem {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--yellow);
  }
</style>
